module.exports = ".maplink li {\r\n    margin: 0.5em 0;\r\n}"